export default __webpack_public_path__ + "static/media/foodx_main.6f6bdc8d.PNG";